(function () {
    'use strict';

    function prettifySlug(value) {
        if (!value) {
            return '';
        }

        return value
            .split('?')[0]
            .split('#')[0]
            .replace(/^\/+|\/+$/g, '')
            .split('/')
            .pop()
            .replace(/[-_]+/g, ' ')
            .replace(/\s+/g, ' ')
            .trim()
            .replace(/\b\w/g, function (char) {
                return char.toUpperCase();
            });
    }

    function hasDiscernibleName(link) {
        var ariaLabel = link.getAttribute('aria-label');
        var ariaLabelledBy = link.getAttribute('aria-labelledby');
        var title = link.getAttribute('title');
        var text = link.textContent.replace(/\s+/g, ' ').trim();

        if (ariaLabel || ariaLabelledBy || title || text) {
            return true;
        }

        var images = link.querySelectorAll('img');

        for (var i = 0; i < images.length; i++) {
            var alt = images[i].getAttribute('alt');

            if (alt && alt.trim() !== '') {
                return true;
            }
        }

        return false;
    }

    function getNearbyText(link) {
        var wrapper = link.closest(
            '.t4s-cat-content, .t4s-collection-item, .t4s-col-item, .t4s-product, .t4s-pr-item, .t4s-section-inner, .t4s-flicky-slider'
        );

        if (!wrapper) {
            return '';
        }

        var titleElement = wrapper.querySelector(
            '.t4s-cat-title, .t4s-cate-title, .t4s-product-title, .t4s-title, h2, h3, h4, [data-title]'
        );

        if (!titleElement) {
            return '';
        }

        return titleElement.textContent.replace(/\s+/g, ' ').trim();
    }

    function getImageAlt(link) {
        var image = link.querySelector('img');

        if (!image) {
            return '';
        }

        var alt = image.getAttribute('alt');

        return alt ? alt.replace(/\s+/g, ' ').trim() : '';
    }

    function getLinkLabel(link) {
        var href = link.getAttribute('href') || '';
        var nearbyText = getNearbyText(link);
        var imageAlt = getImageAlt(link);
        var slugText = prettifySlug(href);
        var labelText = nearbyText || imageAlt || slugText;

        if (
            link.closest('.t4s-header__logo') ||
            href === '/' ||
            href === window.location.origin + '/'
        ) {
            return 'Go to homepage';
        }

        if (href.indexOf('/account') !== -1) {
            return 'Open account login';
        }

        if (href.indexOf('/cart') !== -1) {
            return 'Open cart';
        }

        if (href.indexOf('/search') !== -1) {
            return 'Open search';
        }

        if (href.indexOf('instagram.com') !== -1) {
            return 'Visit The Swell Score on Instagram';
        }

        if (href === '/collections' || href.indexOf('/collections?') !== -1) {
            return 'View all collections';
        }

        if (href.indexOf('/collections/') !== -1) {
            return 'Shop ' + (labelText || 'collection');
        }

        if (href.indexOf('/products/') !== -1) {
            return 'View product ' + (labelText || 'details');
        }

        if (href.indexOf('/pages/') !== -1) {
            return 'Open page ' + (labelText || 'details');
        }

        if (labelText) {
            return 'Open ' + labelText;
        }

        return 'Open link';
    }

    function fixNamelessLinks() {
        var links = document.querySelectorAll('a[href]');

        links.forEach(function (link) {
            if (hasDiscernibleName(link)) {
                return;
            }

            var label = getLinkLabel(link);

            link.setAttribute('aria-label', label);

            /**
             * Title is optional, but useful for debugging.
             */
            if (!link.getAttribute('title')) {
                link.setAttribute('title', label);
            }
        });
    }

    function initA11yLinkNameFix() {
        fixNamelessLinks();

        var observer = new MutationObserver(function () {
            fixNamelessLinks();
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });

        document.addEventListener('shopify:section:load', fixNamelessLinks);
        document.addEventListener('shopify:section:reorder', fixNamelessLinks);
        document.addEventListener('shopify:block:select', fixNamelessLinks);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initA11yLinkNameFix);
    } else {
        initA11yLinkNameFix();
    }
})();